module.exports = __webpack_public_path__ + "img/btn12.7d899558.png";